import { useSyncExternalStore } from 'react';

// The origin cannot change without a full page load, so there is nothing to subscribe to and nothing to tear down.
const subscribe = () => () => undefined;
const getWindowOrigin = () => window.location.origin;

export const useLocationOrigin = (
  /** A stable function (ie. memoized or constant) that is safe to run server-side. */
  getOriginSsr?: () => string
) => {
  return useSyncExternalStore(subscribe, getWindowOrigin, getOriginSsr);
};
